import axios from 'axios';
import enviroment from '../../enviroments/enviroment';
import {
    InterceptorConfig,
    InterceptorError,
} from '../interceptor/interceptor';

const HttpAxios = axios.create({
    baseURL: enviroment.apiURL,
});

HttpAxios.defaults.headers.common['Accept'] = 'application/json';
HttpAxios.defaults.headers.common['Content-Type'] = 'application/json';
HttpAxios.interceptors.request.use(InterceptorConfig, InterceptorError);

export default HttpAxios;
